export default __webpack_public_path__ + "static/media/scoreboard - 1.de67d3c0.jpeg";